import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	backlog: {
		id: 'spa-apps-sidebar-user.menu.backlog',
		defaultMessage: 'Backlog',
		description: 'Navigation item which links to a backlog page in user container',
	},
	headerDescription: {
		id: 'spa-apps-sidebar-user.menu.header-description',
		defaultMessage: 'Boards',
		description: 'Board type description in a user board',
	},
	itemBack: {
		id: 'spa-apps-sidebar-user.menu.item-back',
		defaultMessage: 'Back',
		description: '"Back" nesting menu item.',
	},
	itemReports: {
		id: 'spa-apps-sidebar-user.menu.item-reports',
		defaultMessage: 'Reports',
		description: '"Reports" menu item.',
	},
	kanbanBoard: {
		id: 'spa-apps-sidebar-user.menu.kanban-board',
		defaultMessage: 'Kanban board',
		description: 'Navigation item which links to a kanban board page in user container',
	},
	scrumBoard: {
		id: 'spa-apps-sidebar-user.menu.scrum-board',
		defaultMessage: 'Active sprints',
		description: 'Navigation item which links to a scrum board page in user container',
	},
});
